import React from 'react';

import styles from './index.module.css';

const FeedbackIcon = () => (
  <svg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
    <rect width='36' height='36' rx='18' fill='#DDF7F9' />
    <path
      d='M18.2812 10.6875C16.4171 10.6895 14.6298 11.431 13.3117 12.7492C11.9935 14.0673 11.252 15.8546 11.25 17.7188V23.625C11.25 23.9234 11.3685 24.2095 11.5795 24.4205C11.7905 24.6315 12.0766 24.75 12.375 24.75H18.2812C20.1461 24.75 21.9345 24.0092 23.2531 22.6906C24.5717 21.372 25.3125 19.5836 25.3125 17.7188C25.3125 15.8539 24.5717 14.0655 23.2531 12.7469C21.9345 11.4283 20.1461 10.6875 18.2812 10.6875ZM20.5312 19.6875H15.75C15.6008 19.6875 15.4577 19.6282 15.3523 19.5227C15.2468 19.4173 15.1875 19.2742 15.1875 19.125C15.1875 18.9758 15.2468 18.8327 15.3523 18.7273C15.4577 18.6218 15.6008 18.5625 15.75 18.5625H20.5312C20.6804 18.5625 20.8235 18.6218 20.929 18.7273C21.0345 18.8327 21.0938 18.9758 21.0938 19.125C21.0938 19.2742 21.0345 19.4173 20.929 19.5227C20.8235 19.6282 20.6804 19.6875 20.5312 19.6875ZM20.5312 17.4375H15.75C15.6008 17.4375 15.4577 17.3782 15.3523 17.2727C15.2468 17.1673 15.1875 17.0242 15.1875 16.875C15.1875 16.7258 15.2468 16.5827 15.3523 16.4773C15.4577 16.3718 15.6008 16.3125 15.75 16.3125H20.5312C20.6804 16.3125 20.8235 16.3718 20.929 16.4773C21.0345 16.5827 21.0938 16.7258 21.0938 16.875C21.0938 17.0242 21.0345 17.1673 20.929 17.2727C20.8235 17.3782 20.6804 17.4375 20.5312 17.4375Z'
      fill='#3EB0BB'
    />
  </svg>
);

const ChevronRightIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 256 256'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path d='M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z' />
  </svg>
);

function mentorLabel(mentorName) {
  const trimmed = mentorName?.trim();
  return trimmed || 'your mentor';
}

// The banner intentionally has no dismiss control: it stays until the mentee
// completes the survey (eligibility, and therefore rendering, turns off once
// the survey is done).
export default function PostConversationSurveyBanner({ mentorName, onStart }) {
  const mentor = mentorLabel(mentorName);

  return (
    <div className={styles.banner}>
      <button type='button' className={styles.main} onClick={onStart}>
        <span className={styles.icon} aria-hidden='true'>
          <FeedbackIcon />
        </span>
        <span className={styles.text}>
          <span className={styles.title}>Help us improve mentor support - 2 min</span>
          <span className={styles.subtitle}>Your responses are anonymous and will never be shared with {mentor}.</span>
        </span>
        <span className={styles.chevron} aria-hidden='true'>
          <ChevronRightIcon />
        </span>
      </button>
    </div>
  );
}
